import React, { useState, useContext, useEffect } from "react";
import { Link, useMatch } from "react-router-dom";
import henceforthApi from "../utils/henceforthApi";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import moment from "moment";
import { GlobalContext } from "../context/Provider";
import { getUserProfileImage } from "../utils/constant_value";
function Chats({ getChatListing, getUserPosts }) {
  const match = useMatch("/user/:id");
  const { authState } = useContext(GlobalContext);
  henceforthApi?.setToken(authState?.access_token);

  //userChatHistory
  const [getChatHistory, setGetChatHistory] = useState([]);
  const userDetailsChatHistory = async (id) => {
    let apiRes = await henceforthApi?.User?.getUserChatHistory(
      match?.params?.id,
      id
    );
    setGetChatHistory(apiRes?.data);
    setTimeout(() => {
      let x=document.querySelector('.chatScrollToBottom')
      x.scrollTop=x.scrollHeight
    }, 10)
  };

  useEffect(() => {
    // userDetailsChatHistory();
  }, [match?.params?.id]);
  return (
    <div className="w-100">
      <div className="row">
        {/* col-12  */}
        <div className="col-12">
          <h2>Chats</h2>
          <hr />
        </div>
        {/* col-4  */}
        <div
          className="col-sm-4"
          style={{
            borderRight: "1px solid #e5e5e5",
          }}
        >
          <div className="chat-height">
            <div
              class="nav flex-column nav-pills me-3 chat-button border-start border-end"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              { getChatListing?.map((item, index) => {
                return (
                  <button
                    onClick={() => userDetailsChatHistory(item?._id)}
                    key={index}
                    class={
                      item?._id
                        ? "chat-button button.active"
                        : " chat-button button"
                    }
                    // "nav-link active users-box"
                    id="v-pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-home"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-home"
                    aria-selected="true"
                  >
                    <div className="d-flex gap-2">
                      <img
                        src={getUserProfileImage(item?.profile_pic)}
                        alt="logo"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                        }}
                      />
                      <div className="user-detail">
                        {/* <Link
                        to="/Details_of_User/:page"
                        className="Details_of_User"
                      > */}
                        <p className="m-0" style={{ fontSize: "14px" }}>
                          {item?.other_user?.full_name ? item?.other_user?.full_name : "Not available"}
                        </p>
                        {/* </Link> */}
                        <p className="m-0" style={{ fontSize: "12px" }}>
                          {item?.other_user?.username ? item?.other_user?.username : "Not available"}
                        </p>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        {/* col-8 */}
        <div className="col-sm-8">
          <div className="row">
            <div className="chat-height chatScrollToBottom">
              {/* <div className="vikram"> */}
              {getChatHistory?.map((item, index) => {
                // console.log(moment(Number(getChatHistory[index]?.created_at)).format("DD MMM YYYY") == moment(Number(getChatHistory[index + 1]?.created_at)).format("DD MMM YYYY") ? "" : moment(Number(getChatHistory[index + 1]?.created_at)).format("DD MMM YYYY"))
                return (
                  <>
                    <p class="time-right text-center dateAndTimeOfChat">
                      {index == 0 ? moment(Number(item?.created_at)).format("DD MMM YYYY") : moment(Number(getChatHistory[index - 1]?.created_at)).format("DD MMM YYYY") == moment(Number(getChatHistory[index]?.created_at)).format("DD MMM YYYY") ? "" : moment(Number(getChatHistory[index]?.created_at)).format("DD MMM YYYY")}
                    </p>
                    <div
                      key={index}
                      class="tab-pane fade show active"
                    >
                      <div
                        className={
                          getUserPosts?.user?._id == item?.sent_by?._id
                            ? "left-chat w-100 d-inline-flex gap-2 align-items-start"
                            : "right-chat w-100 d-inline-flex gap-2 align-items-start justify-content-end"
                        }
                      >
                        {getUserPosts?.user?._id == item?.sent_by?._id ? (
                          <img
                            src={getUserProfileImage(item?.profile_pic)}
                            alt="Avatar"
                            className="modal-profile m-0"
                          />
                        ) : (
                          ""
                        )}

                        <div className="chat-main-box">
                          <div
                            className={
                              getUserPosts?.user?._id == item?.sent_by?._id
                                ? "p-3 left-chat-rounded  bg-secondary text-white"
                                : "p-3 right-chat-rounded bg-dark text-white"
                            }
                          >
                            <p className="m-0">{item?.message}</p>
                          </div>
                          <p class="time-right text-end dateAndTimeOfChat">
                            {moment(Number(item?.created_at)).format("h:mm a")}
                          </p>
                        </div>
                      </div>

                      {/* <div class="right-chat w-100 d-inline-flex gap-2 align-items-start justify-content-end">
                  <div className="chat-main-box">
                    <div className="p-3 right-chat-rounded bg-dark text-white">
                      <p className="m-0">{item.message}</p>
                    </div>
                    <p class="time-right text-end">
                      {moment(Number(item.created_at)).format("L, h:mm a")}
                    </p>
                  </div>
                </div> */}
                    </div>
                  </>
                )
              })}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chats;
